import Vue from 'vue';
import shuffleArray from '~/utils/shuffle-array';
import SpecialBannersComponent from '../components/home/special-banners-component';

DM.Module.SpecialBanners = ((DM) => {

    const SELECTOR = '.js-special-banners';

    class SpecialBanners {

        constructor(container) {
            this.items = this.getData();
            this.backgroundColor = DM.Boot.MainPage.mainPageSpecialBanners.backgroundColor;
            this.vm = this.createComponent();
            this.vm.$mount(container);
        }

        getData() {
            const array = DM.Boot.MainPage.mainPageSpecialBanners && DM.Boot.MainPage.mainPageSpecialBanners.specialBanners;
            return [ ...shuffleArray(array) ];
        }

        createComponent() {
            return new Vue({
                components: {
                    'dm-special-banners': SpecialBannersComponent,
                },
                data: {
                    items: this.items,
                    backgroundColor: this.backgroundColor,
                    slots: 2,
                    preload: {
                        sequentially: true,
                    },
                },
                template: '<dm-special-banners :slots="slots" :items="items" :preload="preload" :backgroundColor="backgroundColor" />',
            });
        }
    }

    [].map.call(document.querySelectorAll(SELECTOR), (item) => {
        return new SpecialBanners(item);
    });

})(window.DM);

